module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAHCAYAAABp0096AAAAAXNSR0IArs4c6QAAAQBJREFUOE+Fk0EOgjAQRf8fEhN3yBVw5Zn0DKw8hLrxDp5PSNCNC1PTdoYWBVmQlBZm3vz/S4fd6lm9Lo7cQ1wFISgA7Cl0XRD06+zdr4e9gvFMz+M+Yx37RwBK2Osc3W39liMfZX11gga0pgsAVlAbJoBxw7Dvmw3Asb4CwPej4MS+3N5BP/kMQNYwKGNTTgFYQ1NmAQCCln1ZuzQ9AKoCmWxxiswCk1dhEliy4UcBhQ/fUq3xiowUCDZkFozkmwCwol+qhGyEs8wCVTjmawBoYwaIJligORh8mgPIi08F0U82G8IEQOLMdAtwALEZBSVPsN2CvzlIEy8AdE7iLfgAcnopXaonj+4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/views/images/home/rec.png
// module id = ndXW
// module chunks = 2